<template>
  <v-row>
    <v-col :xl="!['F', 'V', ''].includes(innerItem.lohn_type) ? 8 : 5" :lg="!['F', 'V', ''].includes(innerItem.lohn_type) ? 8 : 6" :md="12" :sm="12">
      <v-card class="m-2">
        <v-card-text>
          <v-row >
            <v-col sm="4" :md="!['F', 'V', ''].includes(innerItem.lohn_type) ? 2 : 4">
              <v-subheader class="c-label">Lohnart</v-subheader>
              <v-subheader class="c-label">Nummer der Lohnart</v-subheader>
              <v-subheader class="c-label">Typ der Lohnart</v-subheader>
              <v-subheader class="c-label">Belegart</v-subheader>
              <v-subheader class="c-label">Gesperrt</v-subheader>
              <v-subheader class="c-label">Buchbar bis</v-subheader>
              <v-subheader class="c-label">Bez. für den Export</v-subheader>
              <v-subheader class="c-label">Beschäftigungsverhältnis</v-subheader>
              <v-subheader class="c-label">Auswerten</v-subheader>
              <v-subheader class="c-label" >An Feiertagen buchen</v-subheader>
              <v-subheader class="c-label" v-if="['E', 'Z', 'ZZ'].includes(innerItem.lohn_type)">Nach Auftragsgruppe</v-subheader>
              <v-subheader class="c-label" v-if="['E', 'F'].includes(innerItem.lohn_type)">An mobile Geräte</v-subheader>
            </v-col>
            <v-col sm="8" :md="!['F', 'V', ''].includes(innerItem.lohn_type) ? 4 : 8">
              <v-text-field
                  class="hide-label"
                  v-model="innerItem.name"
                  :rules="rules.name"
                  counter
                  maxlength="50"
                  hint="Der Name der Lohnart"
                  label="Lohnart"
                  @input="$emit('change', innerItem.id)"
              ></v-text-field>
              <v-text-field
                  class="hide-label"
                  v-model="innerItem.access"
                  :rules="rules.name"
                  counter
                  maxlength="50"
                  :disabled="!canEdit && innerItem.bis_id !== 'Neuanlage'"
                  hint="Die Nummer der Lohnart"
                  label="Nummer der Lohnart"
                  @input="$emit('change', innerItem.id)"
              ></v-text-field>
              <v-select
                  class="hide-label"
                  :items="lohnTypeSelects"
                  v-model="innerItem.lohn_type"
                  :rules="rules.name"
                  label="Belegart"
                  hint="Gibt den Typ der Lohnart an."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-select
                  class="hide-label"
                  :items="lohnUsageTypeSelects"
                  v-model="innerItem.lohn_usage_type"
                  :rules="rules.name"
                  label="Belegart"
                  hint="Gibt an wie die Lohnart gebucht wird."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.blocked"
                  label="Gesperrt"
                  :disabled="!canEdit && innerItem.bis_id !== 'Neuanlage'"
                  hint="Eine gesperrte Lohnart wird nichtmehr gebucht."
                  @input="$emit('change', innerItem.id)"
              ></v-select>

              <v-dialog
                  ref="dialog"
                  v-model="datePickerEntry"
                  :return-value.sync="innerItem.book_till"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      class="hide-label"
                      :value="computedEndDate"
                      label="Buchbar bis"
                      hint="Die Lohnart wird ab diesem Datum nichtmehr gebucht."
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      @click:clear="innerItem.book_till = ''"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="innerItem.book_till"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="datePickerEntry = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(innerItem.book_till); $emit('change', innerItem.id)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-text-field
                  class="hide-label"
                  v-model="innerItem.wage_type_number"
                  counter
                  maxlength="50"
                  hint=""
                  label="Bez. für den Export"
                  @input="$emit('change', innerItem.id)"
              ></v-text-field>
              <v-combobox
                  class="hide-label"
                  :items="employmentTypes"
                  v-model="innerItem.employment_type"
                  label="Beschäftigungsverhältnis"
                  hint="Die Lohnart wird nur für Mitarbeiter mit diesem Beschäftigungsverhältnis gebucht."
                  @input="$emit('change', innerItem.id)"
              ></v-combobox>
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.evaluate"
                  label="Auswerten"
                  hint="Gibt an ob diese Lohnart ausgewertet wird."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.book_on_holidays"
                  label="An Feiertagen buchen"
                  hint="Gibt an ob diese Lohnart an Feiertagen gebucht wird."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-select
                  v-if="['E', 'Z', 'ZZ'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  :items="augrs"
                  v-model="innerItem.only_augr"
                  label="Nach Auftagsgruppe"
                  hint="Diese Lohnart wird automatisch für Tätigkeiten in dieser Auftragsgruppe gebucht."
                  @input="$emit('change', innerItem.id)"
                  item-value="gischl"
                  item-text="name"
              ></v-select>
              <v-select
                  class="hide-label"
                  :items="mobileSelects"
                  v-model="innerItem.dont_send_mobile"
                  label="An Mobile Geräte"
                  hint="Gibt an ob diese Lohnart an mobile Geräte gesendet wird."
                  @input="$emit('change', innerItem.id)"
                  v-if="['E', 'F'].includes(innerItem.lohn_type)"
              ></v-select>
            </v-col>
            <v-divider
                v-if="!['F', 'V', ''].includes(innerItem.lohn_type)"
                vertical
                inset
            ></v-divider>
            <v-col sm="4" md="2" v-if="!['F', 'V', ''].includes(innerItem.lohn_type)">
              <v-subheader class="c-label" v-if="['Z', 'ZZ'].includes(innerItem.lohn_type)" >Automatischer Zuschlag</v-subheader>
              <v-subheader class="c-label" v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)" >Zuschlag Rechnung</v-subheader>
              <v-subheader class="c-label" v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)">Zuschlag Rechnung extern</v-subheader>
              <v-subheader class="c-label" v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)">Zuschlag Lohn</v-subheader>
              <v-subheader class="c-label" v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)">Berechnen mit</v-subheader>
              <v-subheader class="c-label" v-if="['Z', 'ZZ'].includes(innerItem.lohn_type)">Bei RB buchen</v-subheader>
            </v-col>
            <v-col sm="8" md="4" v-if="!['F', 'V', ''].includes(innerItem.lohn_type)">
              <v-select
                  v-if="['Z', 'ZZ'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.automatic_time_surcharge"
                  label="Automatischer Zuschlag"
                  hint="Gibt an ob dieser Zuschlag automatisch berechnet wird. (i.d.R. alles außer Überstundenzuschlag)"
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-text-field
                  v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  v-model="innerItem.surcharge_bill"
                  :rules="rules.percent"
                  counter
                  maxlength="16"
                  hint="Der Prozentsatz des Zuschlags auf die Rechnung"
                  label="Zuschlag Rechnung"
                  @input="$emit('change', innerItem.id)"
                  suffix="%"
              ></v-text-field>
              <v-text-field
                  v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  v-model="innerItem.surcharge_bill_extern"
                  :rules="rules.percent"
                  counter
                  maxlength="16"
                  hint="Der Prozentsatz des Zuschlags auf die externe Rechnung"
                  label="Zuschlag Rechnung extern"
                  @input="$emit('change', innerItem.id)"
                  suffix="%"
              ></v-text-field>
              <v-text-field
                  v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  v-model="innerItem.surcharge_salary"
                  :rules="rules.percent"
                  counter
                  maxlength="16"
                  hint="Der Prozentsatz des Zuschlags auf den Lohn"
                  label="Zuschlag Lohn"
                  @input="$emit('change', innerItem.id)"
                  suffix="%"
              ></v-text-field>
              <v-select
                  v-if="['R', 'M', 'Z', 'ZZ', 'E'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  :items="calculationTypes"
                  v-model="innerItem.calculation_type"
                  label="Berechnen mit"
                  hint="Gibt an wie der Lohnzuschlag (in Stunden) berechnet wird."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
              <v-select
                  v-if="['Z', 'ZZ'].includes(innerItem.lohn_type)"
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.only_rb"
                  label="Bei RB buchen"
                  hint="Gibt an ob dieser Zuschlag nur bei Rufbereitschaft gebucht wird."
                  @input="$emit('change', innerItem.id)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col xl="4" lg="4" md="12" sm="12" v-if="!['F', 'V', ''].includes(innerItem.lohn_type)">
      <v-card class="m-2">
        <v-card-title>Einschränkungen</v-card-title>
        <v-card-text>
          <v-row class="m-0 p-0">
          <v-col cols="4" class="m-0 p-0">
            <v-subheader class="c-label" >Nach Uhrzeit</v-subheader>
           </v-col>
          <v-col cols="8" class="m-0 p-0">
            <v-select
                class="hide-label"
                :items="timeSelects"
                v-model="innerItem.time_dependant_resolved"
                label="Nach Uhrzeit"
                hint="Gibt an ob diese Lohnart an Uhrzeiten gebunden ist."
                @input="$emit('change', innerItem.id);"
            ></v-select>
          </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.time_dependant_resolved === 'split' || innerItem.time_dependant_resolved === 'day'">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >{{innerItem.time_dependant_resolved === 'split' ? 'Früh' : 'Von u. Bis'}}</v-subheader>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_start_1"
                  v-model="menuStart1"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_1_start"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-right: 8px"
                      class="hide-label"
                      v-model="innerItem.time_1_start"
                      label=""
                      placeholder="Von"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuStart1"
                    v-model="innerItem.time_1_start"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_start_1.save(innerItem.time_1_start); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_end_1"
                  v-model="menuEnd1"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_1_end"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-left: 8px"
                      class="hide-label"
                      v-model="innerItem.time_1_end"
                      label=""
                      placeholder="Bis"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuEnd1"
                    v-model="innerItem.time_1_end"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_end_1.save(innerItem.time_1_end); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.time_dependant_resolved === 'split'">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Spät</v-subheader>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_start_2"
                  v-model="menuStart2"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_2_start"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-right: 8px"
                      class="hide-label"
                      v-model="innerItem.time_2_start"
                      label=""
                      placeholder="Von"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuStart2"
                    v-model="innerItem.time_2_start"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_start_2.save(innerItem.time_2_start); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_end_2"
                  v-model="menuEnd2"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_2_end"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-left: 8px"
                      class="hide-label"
                      v-model="innerItem.time_2_end"
                      label=""
                      placeholder="Bis"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuEnd2"
                    v-model="innerItem.time_2_end"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_end_2.save(innerItem.time_2_end); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.time_dependant_resolved === 'night'">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Von u. Bis</v-subheader>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_start_n"
                  v-model="menuStart1"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_1_start"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-right: 8px"
                      class="hide-label"
                      v-model="innerItem.time_1_start"
                      label=""
                      placeholder="Von"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuStart1"
                    v-model="innerItem.time_1_start"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_start_n.save(innerItem.time_1_start); handleNightMode(); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="m-0 p-0">
              <v-menu
                  ref="menu_end_n"
                  v-model="menuEnd1"
                  :close-on-content-click="false"
                  :return-value.sync="innerItem.time_2_end"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      style="padding-left: 8px"
                      class="hide-label"
                      v-model="innerItem.time_2_end"
                      label=""
                      placeholder="Bis"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuEnd1"
                    v-model="innerItem.time_2_end"
                    full-width
                    format="24hr"
                    @click:minute="$refs.menu_end_n.save(innerItem.time_2_end); handleNightMode(); $emit('change', innerItem.id)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Nach Wochentagen</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="weekdays"
                  v-model="innerItem.weekdays"
                  label="Nach Wochentagen"
                  hint="An welchen Wochentagen wird diese Lohnart gebucht."
                  multiple
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Nach Feiertagen</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.special_rules"
                  label="Nach Feiertagen"
                  hint="Greifen gesonderte Regeln an Feiertagen."
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.special_rules">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Vor Feiertag</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.before_holiday"
                  label="Vor Feiertag"
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.special_rules">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Am Feiertag</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="holidaySelects"
                  v-model="innerItem.on_holiday"
                  label="Am Feiertag"
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="innerItem.special_rules">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Nach Feiertag</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="selects"
                  v-model="innerItem.after_holiday"
                  label="Nach Feiertag"
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="m-0 p-0">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Nach Datum</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="datesSelects"
                  v-model="innerItem.for_dates"
                  label="Nach Datum"
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0 inner-rules" v-if="this.innerItem.for_dates !== '0'">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Tage</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-menu
                  ref="menu_dates"
                  v-model="menuDates"
                  :close-on-content-click="false"
                  :return-value.sync="externalDates"
                  transition="scale-transition"
                  offset-y
                  left
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                      class="hide-label"
                      v-model="dates"
                      multiple
                      chips
                      small-chips
                      placeholder="Tage wählen"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @input=""
                  ></v-combobox>
                </template>
                <v-date-picker
                    v-model="externalDates"
                    multiple
                    no-title
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="menuDates = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_dates.save(externalDates); $emit('change', innerItem.id)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="m-0 p-0">
            <v-col cols="4" class="m-0 p-0">
              <v-subheader class="c-label" >Nach Arbeitszeit</v-subheader>
            </v-col>
            <v-col cols="8" class="m-0 p-0">
              <v-select
                  class="hide-label"
                  :items="workTimeSelects"
                  v-model="innerItem.working_hours"
                  label="Nach Arbeitszeit"
                  hint="Soll diese Lohnart nur zu bestimmten Arbeitszeiten gebucht werden."
                  @input="$emit('change', innerItem.id);"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "lohn_detail",
  props:{
    employmentTypes: {
      type: Array,
      default: () => []
    },
    augrs: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
        }
      }
    },
  },
  data () {
    return {
      innerItem: {
        id: '',
        bis_id: 'Neuanlage',
        kloon_id: 0,
        name: '',
        access: '',
        lohn_type: '',
        blocked: false,
        wage_type_number: '',
        unit: '',
        export_payroll: false,
        evaluate: false,
        lohn_usage_type: '',
        employment_type: '',
        automatic_time_surcharge: false,
        time_dependant: false,
        time_1_start: '',
        time_1_end: '',
        time_2_start: '',
        time_2_end: '',
        weekday_dependant: false,
        weekdays: '',
        special_rules: false,
        before_holiday: false,
        on_holiday: '0',
        after_holiday: false,
        time_comparison: '0',
        book_till: '',
        book_on_holidays: false,
        surcharge_bill: '0',
        surcharge_bill_extern: '0',
        surcharge_salary: '0',
        calculation_type: '+',
        only_augr: '',
        dont_send_mobile: false,
        only_rb: false,
        for_dates: 'N',
        dates: '',
        working_hours: '',
        time_dependant_resolved: '',
      },
      menuStart1: false,
      menuStart2: false,
      menuEnd1: false,
      menuEnd2: false,
      menuDates: false,
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        kost: [val => (val || '').length > 0 || '*erforderlich'],
        percent: [
          value => !!value || '*erforderlich',
          value => {
            const pattern = /^\d+$/
            return pattern.test(value) || 'Nur Zahlen erlaubt'
          },
        ],
      },
      datePickerEntry: false,
      datePickerExit: false,
      selects: [{text: "Ja", value: true}, {text: "Nein", value: false}],
      mobileSelects: [{text: "nicht versenden", value: true}, {text: "versenden", value: false}],
      externalDates: [],
      dates: [],
      ignoreUpdate: false,
      lohnUsageTypeSelects: [
          {text: "Abbuchung Stunden (PE02)", value: '1PE02'},
        {text: "Abbuchung Tage (PE05)", value: '2PE05'},
        {text: "Zubuchung Stunden (PE06)", value: '1PE06'},
        {text: "Zubuchung Tage (PE07)", value: '2PE07'},
        {text: "Pauschale/Stunde", value: '3PE02'},
        {text: "Pauschale/Tag", value: '3PE05'},
      ],
      lohnTypeSelects: [
        {value: "V", text: "Vortragsbuchung"},
        {value: "R", text: "Rufbereitschaft"},
        {value: "M", text: "Mehrarbeitszeit"},
        {value: "F", text: "Fehlzeit"},
        {value: "Z", text: "Zuschlag Lohnabrechnung"},
        {value: "ZZ", text: "Zuschlag Zeitkonto"},
        {value: "E", text: "Erschwerniszuschlag"}
      ],
      calculationTypes: [
        {value: "+", text: "+ [z.B. 1:00 + 50% = 1:30]"},
        {value: "*", text: "* [z.B. 1:00 * 50% = 0:30]"},
        {value: "e", text: "in Euro"},
      ],
      timeSelects: [
        {value: "", text: "Nein"},
        {value: "split", text: "Früh und Spät"},
        {value: "day", text: "Tagsüber"},
        {value: "night", text: "Über Mitternacht"},
      ],
      weekdays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
      workTimeSelects: [
        {value: "", text: "Nein"},
        {value: "in", text: "Innerhalb der Arbeitszeit"},
        {value: "out", text: "Außerhalb der Arbeitszeit"},
      ],
      holidaySelects: [
        {value: "0", text: "nicht gesetzt"},
        {value: "1", text: "am Feiertag"},
        {value: "~", text: "nicht am Feiertag"},
      ],
      datesSelects: [
        {value: "0", text: "Nein"},
        {value: "1", text: "jeweils am"},
        {value: "~", text: "nicht am"},
      ],
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.innerItem = {...newVal};
        this.cleanData();
      },
      deep: true
    },
    externalDates: function (newVal) {
      if (this.ignoreUpdate) {
        return;
      }
      this.dates = newVal.map(function (el) {
        return el.split('-').splice(1, 2).reverse().join('.') + ".";
      });
    }
  },
  computed: {
    computedEndDate () {
      return this.innerItem.book_till ? this.innerItem.book_till.split('-').reverse().join('.') : 'offen'
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.innerItem = {...this.item};
    this.cleanData();
    },
  methods: {
    handleNightMode() {
      if (this.innerItem.time_1_start !== "" && this.innerItem.time_2_end !== "") {
        this.innerItem.time_1_end = '23:59';
        this.innerItem.time_2_start = '00:00';
      }
    },
    isValid() {
      return this.innerItem.name.trim().length > 0;
    },
    cleanData() {
      this.ignoreUpdate = true;
      this.$set(this.innerItem, 'time_dependant_resolved', '');
      if (this.innerItem.time_dependant) {
        if (this.innerItem.time_1_end === '23:59' && this.innerItem.time_2_start === '00:00') {
          this.innerItem.time_dependant_resolved = 'night';
        } else if (this.innerItem.time_1_end !== '' && this.innerItem.time_2_start !== '') {
          this.innerItem.time_dependant_resolved = 'split';
        } else if (this.innerItem.time_1_end !== '' && this.innerItem.time_2_start === '') {
          this.innerItem.time_dependant_resolved = 'day';
        }
      } else {
        this.innerItem.time_1_start = '';
        this.innerItem.time_1_end = '';
        this.innerItem.time_2_start = '';
        this.innerItem.time_2_end = '';
      }
      if (this.innerItem.weekday_dependant) {
        this.innerItem.weekdays = this.innerItem.weekdays.split(',');
        // remove empty strings
        this.innerItem.weekdays = this.innerItem.weekdays.filter(function (el) {
          return el !== '';
        });
      } else {
        this.innerItem.weekdays = [];
      }
      this.externalDates = [];
      this.dates = [];
      if (this.innerItem.for_dates !== '0') {
        this.dates = this.innerItem.dates.split(',').filter(function (el) {
          return el !== '';
        });
        for (let i = 0; i < this.dates.length; i++) {
          this.externalDates.push('' + new Date().getFullYear() + '-' +(this.dates[i].split('.').splice(0, 2).reverse().join('-')));
        }
      }
      this.ignoreUpdate = false;
    },
    resetEdit() {
      this.innerItem = {...this.item};
      this.cleanData();
    },
    getData() {
      let res = {...this.innerItem};
      res.time_dependant = res.time_dependant_resolved !== '' && (
          (res.time_1_start !== '' && res.time_1_end !== '') || (res.time_2_start !== '' && res.time_2_end !== ''));
      if (!res.time_dependant) {
        res.time_1_start = '';
        res.time_1_end = '';
        res.time_2_start = '';
        res.time_2_end = '';
      }
      if (res.time_dependant && this.innerItem.time_dependant_resolved === 'day') {
        res.time_2_start = '';
        res.time_2_end = '';
      }
      res.weekdays = res.weekdays.join(',');
      res.weekday_dependant = res.weekdays !== '';
      if (res.for_dates !== '0') {
        res.dates = this.dates.join(',');
      } else {
        res.dates = '';
      }
      return res;
    }
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.70);
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.70);
}

::v-deep .hide-label {
  padding-top: 0px !important;
}

::v-deep .hide-label .v-label {
  display: none !important;
}

.c-label {
  margin-bottom: 10px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}

.inner-rules {
  padding-right: 24px!important;
  padding-left: 24px!important;
}

</style>
